<template>
  <div>

    <a-modal
      title="指派"
      style="top: 20px;"
      :width="1000"
      v-model="bisible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :closable="false"
      :maskClosable="false"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="核销负责人">
          <a-select v-decorator="['writeoffUserCharge',{ rules: [{ required: true, message: '请选择核销负责人' }] }]">
            <a-select-option v-for="type in data6" :key="type.userId">{{type.userName}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="核销详情"
      style="top: 20px;"
      :width="1000"
      v-model="visible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit1"
      :closable="false"
      :maskClosable="false"
      :destroyOnClose="true"
    >
      <a-form :form="form">
        <div style="padding: 10px" v-for="(item,index) in data1" v-if="item.isRelation == 1" :key="index">
          <a-form-item>                                             <!--判断 没有关联关系的显示-->
            <div style="padding: 10px">
              <span v-if="item.isReply == 1" style="color: red;margin-right: 5px">*</span>
              <span>{{item.sort}}. </span>
              <span style="background-color:#1890ff;color: #fff;margin: 0 10px;padding: 2px 10px;border-radius: 6px">{{item.subjectType}}</span>
              <span> {{item.subjectName}}</span>
            </div>
            <div style="margin-left: 95px;padding:0 15px" class="test">
              <!--单选-->
              <div v-if="item.subjectType == '单选题'">
                <a-radio-group v-decorator ="['value' + item.sort,{rules: [{ required: true, message: '请选择'}]}]" :required="false" @change="onChange(index,$event)" v-if="item.isReply == 1">
                  <a-radio v-for="int in item.optionList" :value="int.optionName" :key="int.optionId" style="margin-right: 30px">
                    {{int.optionName}}
                  </a-radio>
                </a-radio-group>
                <a-radio-group v-decorator ="['value' + item.sort]" :required="false" @change="onChange(index,$event)" v-else>
                  <a-radio v-for="int in item.optionList" :value="int.optionName" :key="int.optionId" style="margin-right: 30px">
                    {{int.optionName}}
                  </a-radio>
                </a-radio-group>
              </div>
              <!--评分-->
              <div  v-else-if="item.subjectType == '选择星级'">
                <a-rate v-decorator ="['value' + item.sort,{rules: [{ required: true, message: '请选择'}],initialValue: 5}]" v-if="item.isReply == 1"/>
                <a-rate v-decorator ="['value' + item.sort,{initialValue: 5}]" v-else/>
              </div>
              <!--多选-->
              <div v-else-if="item.subjectType == '多选题'">
                <a-checkbox-group
                  v-decorator ="['value' + item.sort,{rules: [{ required: true, message: '请选择'}]}]"
                  @change="handleCheck(index,$event)"
                  v-if="item.isReply == 1"
                >
                  <a-checkbox v-for="type in item.optionList" :key="type.optionId" :value="type.optionName">
                    {{type.optionName}}
                  </a-checkbox>
                </a-checkbox-group>
                <a-checkbox-group
                  v-decorator ="['value' + item.sort]"
                  @change="handleCheck(index,$event)"
                  v-else
                >
                  <a-checkbox v-for="type in item.optionList" :key="type.optionId" :value="type.optionName">
                    {{type.optionName}}
                  </a-checkbox>
                </a-checkbox-group>
              </div>
              <!--下拉框-->
              <div  v-else-if="item.subjectType == '下拉框'">
                <a-select  v-decorator ="['value' + item.sort,{rules: [{ required: true, message: '请输入'}]}]" v-if="item.isReply == 1" @change="handleSelect(index,$event)">
                  <a-select-option  v-for="type in item.optionList" :key="type.optionName" :value="type.optionName">{{type.optionName}}</a-select-option>
                </a-select>
                <a-select  v-decorator ="['value' + item.sort]" v-else @change="handleSelect(index,$event)">
                  <a-select-option  v-for="type in item.optionList" :key="type.optionName" :value="type.optionName">{{type.optionName}}</a-select-option>
                </a-select>
              </div>
              <!--输入框-->
              <div  v-else-if="item.subjectType == '单项填空题'">
                <a-input  v-decorator ="['value' + item.sort,{rules: [{ required: true, message: '请输入'}]}]" v-if="item.isReply == 1"></a-input>
                <a-input  v-decorator ="['value' + item.sort]" v-else></a-input>
              </div>
            </div>
          </a-form-item>
          <a-divider dashed/>
        </div>
      </a-form>
    </a-modal>

  </div>
</template>

<script>
  import { insert,firstList,editWriteoffUserCharge } from '@/api/order/cancelList'
  import pick from 'lodash.pick'
  import store from '@/store'
  import AFormItem from "ant-design-vue/es/form/FormItem";
  export default {
    name: "cancelListModel",
    components: {AFormItem},
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        mdl: {},
        queryParam: {},
        visible: false,
        bisible: false,
        form: this.$form.createForm(this),
        arr: '', //指派
        data1: '', //筛选后的题目
        data6:'', // 核销负责人
        text:'', //单选题 选中的值
        orderId:'',
        userId:'',
      }
    },
    async created () {
      this.userId = store.getters.userId
    },
    methods: {
      // 指派
      designate(record,data){
        this.form.resetFields()
        console.log(record,data)
        let arr = []
        for(var item of record){
          console.log(item.orderId)
          arr.push(item.orderId)
        }
        this.arr = arr
        this.data6 = data
        this.bisible = true
      },
      // 核销详情
      edit(record,key){
        console.log(key)
        this.visible = true
        this.form.resetFields()
        this.orderId = record.orderId
        // this.orderId = "444994489489465"
        // console.log(record)
        // 所有题目
        firstList({orderId:record.orderId}).then(res=>{

          console.log(res.rows)
          let rows = res.rows
          rows.map(function (val) {
            // console.log(val)
            val.text = ""
            val.score = ''
            // if(val.isReply == 1){
            //   val.isReply = 'true'
            // }else{
            //   val.isReply = 'false'
            // }
            if (val.subjectType == 0) {
              val.subjectType = '单选题'
            } else if (val.subjectType == 1) {
              val.subjectType = '多选题'
            } else if (val.subjectType == 2) {
              val.subjectType = '下拉框'
            } else if (val.subjectType == 3){
              val.subjectType = '单项填空题'
            } else if (val.subjectType == 4){
              val.subjectType = '选择星级'
            }
          })
          this.data1 = rows
          // console.log('更改题型后的数据',this.data1)
        })
      },
      // 单选题
      onChange(index,e) {
        // console.log('单选',index,e.target.value);
        // console.log('当前所选题目',this.data1[index])
        for(let item of this.data1[index].optionList){ // 所选题目的选项
          var text = this.data1[index].text// 选项关联的初始值
          if(item.optionName == e.target.value){ //如果题目选项中name值，与被选中的value值相同
            // console.log('被选中项的关联id',item.optionSubjectId)  //被选中项的关联id
            this.data1[index].score = item.penaltyValue
            // console.log(this.data1[index].score)
            if(item.optionSubjectId.length != 0){
              if (text.length != 0) {
                // 先隐藏之前选项的关联题
                for (let a=0;a<this.data1.length;a++) {
                  for (let b=0; b<text.length; b++){
                    if(this.data1[a].subjectId == text[b]){
                      // console.log('需要隐藏的题目',this.data1[a])
                      this.data1[a].isRelation = 0
                    }
                  }
                }
                console.log(item.optionSubjectId,item.penaltyValue)
                // 显示当前选项的关联题,并给text 重新赋值
                this.data1[index].text= item.optionSubjectId
                for(let tet=0;tet<this.data1.length;tet++){ // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                  for (let val=0;val<item.optionSubjectId.length;val++){
                    if(this.data1[tet].subjectId == item.optionSubjectId[val]){
                      this.data1[tet].isRelation = 1
                    }
                  }
                }
              } else {
                console.log(item.optionSubjectId,item.penaltyValue)
                this.data1[index].text = item.optionSubjectId
                console.log('text新值2',this.data1[index].text)
                for(let tet=0;tet<this.data1.length;tet++){ // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                  for (let val=0;val<item.optionSubjectId.length;val++){
                    if(this.data1[tet].subjectId == item.optionSubjectId[val]){
                      this.data1[tet].isRelation = 1
                    }
                  }
                }
              }
            }else{
              for(let tet of this.data1){ // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                if(text.length != 0){  // 将之前选中的关联题隐藏
                  for(let i=0;i<text.length;i++){
                    if(tet.subjectId == text[i]){
                      console.log(tet)
                      tet.isRelation = 0
                      console.log('进入清空')
                      text = []
                    }
                  }
                }
              }
            }
          }
        }
      },
      // 下拉单选框
      handleSelect(index,value){
        // console.log('单选框',index,value)
        for(let item of this.data1[index].optionList){ // 所选题目的选项
          var text = this.data1[index].text// 选项关联的初始值
          if(item.optionName == value){ //如果题目选项中name值，与被选中的value值相同
            // console.log('被选中项的关联id',item.optionSubjectId)  //被选中项的关联id
            this.data1[index].score = item.penaltyValue
            if(item.optionSubjectId.length != 0){
              if (text.length != 0) {
                // 先隐藏之前选项的关联题
                for (let a=0;a<this.data1.length;a++) {
                  for (let b=0; b<text.length; b++){
                    if(this.data1[a].subjectId == text[b]){
                      // console.log('需要隐藏的题目',this.data1[a])
                      this.data1[a].isRelation = 0
                      this.data1[a].score = 0
                      // console.log('已隐藏')
                    }
                  }
                }
                // 显示当前选项的关联题,并给text 重新赋值
                this.data1[index].text= item.optionSubjectId
                for(let tet=0;tet<this.data1.length;tet++){ // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                  for (let val=0;val<item.optionSubjectId.length;val++){
                    if(this.data1[tet].subjectId == item.optionSubjectId[val]){
                      this.data1[tet].isRelation = 1
                      console.log('已显示')
                    }
                  }
                }
              } else {
                console.log(item.optionSubjectId)
                this.data1[index].text = item.optionSubjectId
                console.log('text新值2',this.data1[index].text)
                for(let tet=0;tet<this.data1.length;tet++){ // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                  for (let val=0;val<item.optionSubjectId.length;val++){
                    if(this.data1[tet].subjectId == item.optionSubjectId[val]){
                      this.data1[tet].isRelation = 1
                    }
                  }
                }
              }
            }else{
              for(let tet of this.data1){ // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                if(text.length != 0){  // 将之前选中的关联题隐藏
                  for(let i=0;i<text.length;i++){
                    if(tet.subjectId == text[i]){
                      console.log(tet)
                      tet.isRelation = 0
                      console.log('进入清空')
                      text = []
                    }
                  }
                }
              }
            }
          }
        }
      },
      // 多选题
      handleCheck(index,values){
        let that = this
        console.log('多选',index,values)
        let arr11 = []
        let arr12 = []
        let text = this.data1[index].text
        let arr = []  // 合并所有关联的id
        for(let item of this.data1[index].optionList){
          // console.log(item)
          for (let tet of values){
            if(item.optionName == tet){
              arr = arr.concat(item.optionSubjectId);
              arr11.push(item.penaltyValue)
              arr12.push(item.optionSubjectId)
            }
          }
        }
        this.data1[index].score = arr11
        let arr1 = [];  // 合并id去重
        for(let i=0; i<arr.length; i++) {
          if(arr1.indexOf(arr[i]) == -1) {
            arr1.push(arr[i])
          }
        }
        // console.log(arr1,arr11,arr12)  //最终关联id集合数组
        if(arr1.length != 0 && text.length == 0){  // 当有关联id，text初始为【】，初次赋值text
          this.data1[index].text = arr1
          for(let item of this.data1){
            for(let a=0;a<arr1.length;a++){
              // console.log(arr1[a])
              if(item.subjectId == arr1[a]){
                // console.log(item,that.data1[index].subjectId)
                item.isRelation = 1
              }
            }
          }
        }else if(arr1.length != 0 && text.length != 0){ //当有关联id，text有值，先隐藏text中的id，再重新赋值text，新的关联id显示
          for(let item of this.data1){
            for(let a=0;a<text.length;a++){
              // console.log(arr1[a])
              if(item.subjectId == text[a]){
                // console.log(item)
                item.isRelation = 0
              }
            }
          }
          this.data1[index].text = arr1
          for(let item of this.data1){
            for(let a=0;a<arr1.length;a++){
              // console.log(arr1[a])
              if(item.subjectId == arr1[a]){
                // console.log(item)
                item.isRelation = 1
              }
            }
          }
        }else if(arr1.length == 0 && text.length != 0){  // 当没有关联id,text有值时，将之前显示的题目隐藏
          for(let item of this.data1){
            for(let a=0;a<text.length;a++){
              // console.log(arr1[a])
              if(item.subjectId == text[a]){
                // console.log(item)
                item.isRelation = 0
                item.text = []
              }
            }
          }
        }console.log(this.data1)
      },
      // 指派
      handleSubmit (e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            values.orderIds = this.arr
            // console.log('Received values of form: ', values)
            this.confirmLoading = true
            editWriteoffUserCharge(values).then(res => {
              // console.log(values)
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok')
                this.bisible = false
              } else {
                this.$message.success(res.msg)
              }
            }).catch(() => {
              this.$message.error('系统错误，请稍后再试')
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        })
      },
      // 核销详情
      handleSubmit1 (e) {
        e.preventDefault()
        var that =this
        // console.log(this.data1)
        this.form.validateFields((err, values) => {
          // console.log(err,values)
          if (!err) {
            // this.confirmLoading = true
            let data2 = []
            let answer = []
            for (let i = 0; i < this.data1.length; i++) {
              if(this.data1[i].isRelation == 1) {
                data2.push(this.data1[i])
              }
            }
            // 多選
            for(let key in values){
              if(Array.isArray(values[key])){
                values[key] = values[key].join('-')
              }
            }
            // console.log(values)
            // console.log(data2,'data2999') // 所有显示出来的题目
            for(let s=0; s<data2.length; s++){
              console.log(data2[s])
              let str = {}
                str.subjectId = data2[s].subjectId
                str.createBy = this.userId
                str.updateBy = this.userId
              if(data2[s].subjectType == '多选题'){
                str.orderId = this.orderId
                str.subjectName = data2[s].subjectName
                str.optionName = values['value'+data2[s].sort]
                answer.push(str)
                if(data2[s].score.length != 0){
                  str.penaltyValue = data2[s].score.join('-')
                }else{
                  str.penaltyValue = data2[s].score
                }
              }else{
                str.orderId = this.orderId
                str.subjectName = data2[s].subjectName
                str.penaltyValue = data2[s].score
                str.optionName = values['value'+data2[s].sort]
                answer.push(str)
              }
            }
            // console.log(answer)
            insert(answer).then(res => {
              if (res.code === 0) {
                that.$nextTick(()=>{
                  that.$emit('ok')
                  that.$message.success('保存成功')
                  that.visible = false
                })
              } else {
                that.$message.success(res.msg)
              }
            }).catch(() => {
              that.$message.error('系统错误，请稍后再试')
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      },
    }
  }
</script>

<style scoped>
  /deep/ .ant-form-explain {
    display: inline-block !important;
    position: relative !important;
    top: -39px !important;
    left:15px !important;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 6px 16px;}
</style>